import { render, staticRenderFns } from "./HeroBar.vue?vue&type=template&id=928126e4&"
import script from "./HeroBar.vue?vue&type=script&lang=js&"
export * from "./HeroBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports